export const WHOLE_CLASS = 'wholeclass'
export const WORKSPACE = 'workspace'
export const HANDOUT = 'handout'
